<template>
  <div
    class="row hero"
    :class="layout"
    :style="{
      'align-items':
        $route.name == 'deixe-seu-perfil' || $route.name == 'meu-perfil'
          ? 'flex-start'
          : 'center',
    }"
  >
    <div
      class="
        text
        col-12 col-sm-10 col-md-8 col-xl-6
        d-flex
        flex-column
        justify-content-center
      "
    >
      <h1
        class="text-white m-0"
        :style="{
          'font-weight':
            $route.name == 'deixe-seu-perfil' || $route.name == 'meu-perfil'
              ? '300'
              : 'bold',
        }"
      >
        {{ title }}
      </h1>
    </div>

    <div class="media-content">


    </div>
  </div>
</template>

<script>
export default {
  name: "Hero",

  props: {
    title: String,
    video: String,
    search: Boolean,
    image: String,
    layout: String,
  },

  components: {},
};
</script>

<style lang="scss">
.hero {
  width: 100vw;
  height: 60vh;
  min-height: 400px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @include media-breakpoint-down(md) {
    min-height: auto;
    height: 40vh;
  }

  &:after {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: rgba(35, 31, 31, 0.5);
  }

  &.md {
    height: 40vh;
    min-height: auto;
    overflow: unset;

    & > .media-content {
      width: 100vw;
      height: 100%;
      top: 0;
      left: 0;
    }
  }

  & > .text {
    z-index: 1;
    .input-group {
      .form-control,
      .btn {
        height: calc(4rem + 2px);
        display: flex;

        &::placeholder {
          opacity: 0.5;
        }
      }
    }

    h1 {
      font-size: 3.5rem;
      font-weight: 600;
      text-align: center;
      font-family: $font-family-base;

      @include media-breakpoint-down(md) {
      }
    }
  }

  & > .media-content,
  & > .media-content > img,
  & > .media-content > video {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: middle;
    overflow: hidden;
  }

  *::-webkit-media-controls-panel {
    display: none !important;
    -webkit-appearance: none;
  }

  *::--webkit-media-controls-play-button {
    display: none !important;
    -webkit-appearance: none;
  }

  *::-webkit-media-controls-start-playback-button {
    display: none !important;
    -webkit-appearance: none;
  }
}
</style>
